import { createSymbiote } from 'redux-symbiote';

const initialState = [];

export const { actions, reducer } = createSymbiote(
  initialState,
  {
    setNotifications: (state, data) => [...data],
  },
  'notification'
);
